import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { CaretRight } from "styled-icons/boxicons-regular/CaretRight";
import styled from "styled-components";
const CrumbItem = ({ to, glyph, children, external, ...props }) => (
  <LinkContainer to={to}>
    <Breadcrumb.Item {...props}>
      {glyph ? (
        <FontSpan>
          <CaretRight
            className="breadcrumb-caret-right"
            icon={["fas", "caret-right"]}
            size="5"
          />{" "}
          {children}
        </FontSpan>
      ) : (
        children
      )}
    </Breadcrumb.Item>
  </LinkContainer>
);

export default CrumbItem;
const FontSpan = styled.span`
font-size :10px
fonr-familty : Trebuchet MS`;
